import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _isArray from 'lodash/isArray'
import { fromJS } from 'immutable'
import { getBoundActions } from '../../actions/index'
import connectRouter from '../Router/connect'
import { connect as connectStaticText } from '../StaticText/connect'
import Link from '../Link/index'
import TileHero from '../TileHero/index'
import Vote, { SIZE_SMALL as VOTE_SIZE_SMALL } from '../Vote/index'
import ProgressBar from '../ProgressBar/index'
import { formatDuration } from '../../theme/web-app/index'
import {
  TYPE_CONTENT_EPISODE,
  TYPE_CONTENT_EPISODE_YOGA,
  TYPE_CONTENT_EPISODE_FITNESS,
  TYPE_CONTENT_EPISODE_MEDITATION,
  TYPE_CONTENT_SEGMENT,
  TYPE_CONTENT_SEGMENT_YOGA,
  TYPE_CONTENT_SEGMENT_FITNESS,
  TYPE_CONTENT_SEGMENT_MEDITATION,
  TYPE_CONTENT_EPISODE_GUIDE,
  TYPE_CONTENT_VIDEO,
  TYPE_CONTENT_SERIES,
} from '../../services/content-type/index'
import { WATCH_NODE_TYPE_FEATURE } from '../Watch/index'
import WatchAccess, {
  ACCESS_CHECK_SHARE_FEATURE_GEO,
  ACCESS_CHECK_AUTH_FEATURE_GEO,
  ACCESS_PREVIEW,
  ACCESS_FEATURE,
} from '../WatchAccess/index'
import WatchAccessAllowed from '../WatchAccessAllowed/index'
import WatchAccessDenied from '../WatchAccessDenied/index'
import NotAvailable, {
  TYPE_NOT_AVAILABLE_OVERLAY,
} from '../NotAvailable/index'
import TextSeasonEpisode from '../TextSeasonEpisode/index'
import { upstreamContextOnClick } from '../../services/upstream-context/index'
import { CLICK_TO_DETAILS_PAGE_GA4_EVENT } from '../../services/event-tracking/index'

const VIDEO_TITLE = 'video-title'
const SERIES_TITLE = 'series-title'

function renderTileProgressBar (userInfo, duration) {
  if (!userInfo || !duration || !userInfo.get('featurePosition')) {
    return null
  }
  return (
    <div className="tile-episode__progress-bar">
      <ProgressBar duration={duration} userInfo={userInfo} />
    </div>
  )
}

function renderBottomMeta (props, formatDurationFunc) {
  const {
    yogaLevelPath,
    yogaStylePath,
    yogaDurationPath,
    fitnessLevelPath,
    fitnessStylePath,
    fitnessDurationPath,
    isGuide,
  } = props
  const meta = []
  const metaClassName = 'tile-episode__meta-item'

  switch (props.type) {
    case TYPE_CONTENT_EPISODE:
    case TYPE_CONTENT_SEGMENT:
    case TYPE_CONTENT_EPISODE_GUIDE:
      meta.push(
        <span className={metaClassName} key={`tile-episode-counts-${props.id}`}>
            <TextSeasonEpisode
              className={['tile-episode__season-episode']}
              season={props.season}
              episode={props.episode}
              isGuide={isGuide}
            />
          </span>,
      )
      break
    case TYPE_CONTENT_EPISODE_YOGA:
    case TYPE_CONTENT_SEGMENT_YOGA:
      if (props.yogaStyle) {
        meta.push(
          <span
            className={metaClassName}
            key={`tile-episode-yoga-style-${props.id}`}
          >
              { getMetaItem(props.yogaStyle, yogaStylePath) }
            </span>,
        )
      }

      if (props.yogaLevel) {
        meta.push(
          <span
            className={metaClassName}
            key={`tile-episode-yoga-level-${props.id}`}
          >
              { getMetaItem(props.yogaLevel, yogaLevelPath) }
            </span>,
        )
      }
      break

    case TYPE_CONTENT_EPISODE_FITNESS:
    case TYPE_CONTENT_SEGMENT_FITNESS:
      if (props.fitnessStyle) {
        meta.push(
          <span
            className={metaClassName}
            key={`tile-episode-fitness-style-${props.id}`}
          >
              { getMetaItem(props.fitnessStyle, fitnessStylePath) }
            </span>,
        )
      }

      if (props.fitnessLevel) {
        meta.push(
          <span
            className={metaClassName}
            key={`tile-episode-fitness-level-${props.id}`}
          >
              { getMetaItem(props.fitnessLevel, fitnessLevelPath) }
            </span>,
        )
      }
      break

    case TYPE_CONTENT_EPISODE_MEDITATION:
    case TYPE_CONTENT_SEGMENT_MEDITATION:
      if (props.meditationStyle) {
        meta.push(
          <span
            className={metaClassName}
            key={`tile-episode-meditation-style-${props.id}`}
          >
              {props.meditationStyle}
            </span>,
        )
      }
      break
    default:
      return null
  }

  if (props.duration) {
    meta.push(
      <span
        className={`${metaClassName} ${metaClassName}--last`}
        key={`tile-episode-duration-${props.id}`}
      >
          {
            fitnessDurationPath || yogaDurationPath
              ? <Link to={fitnessDurationPath || yogaDurationPath}>
                {formatDurationFunc(props.duration)}
              </Link> : formatDurationFunc(props.duration)
          }
        </span>,
    )
  }

  if (
    props.type !== TYPE_CONTENT_EPISODE
    && props.type !== TYPE_CONTENT_SEGMENT
    && props.type !== TYPE_CONTENT_EPISODE_GUIDE
  ) {
    meta.push(
      <span className={metaClassName} key={`tile-episode-counts-${props.id}`}>
          <TextSeasonEpisode
            className={['tile-episode__season-episode']}
            season={props.season}
            episode={props.episode}
          />
        </span>,
    )
  }

  return meta
}

function renderLabel (value) {
  if (value) {
    return <div className="tile-episode__label">{value}</div>
  }
  return null
}

function getMetaItem (type, path) {
  return (
    path
      ? <Link to={path}>
        {type}
      </Link>
      : type
  )
}

function renderTopMeta (props, renderSeriesTitleFunc) {
  if (props.seriesTitle) {
    return renderSeriesTitleFunc(props.seriesTitle, props.seriesPath)
  }
  return null
}

class TileEpisode extends Component {
  onClickTitle = (evt) => {
    const { props } = this
    const {
      id,
      title,
      feature,
      uiLocation,
      mediaLanguage,
      parentSeriesTitle,
      parentSeriesId,
      upstreamContext,
      setUpstreamContext,
      setEventDefault,
    } = props
    const linkType = evt.currentTarget.getAttribute('data-element')
    const isSeriesTitle = linkType === SERIES_TITLE

    // GA4 events
    if (isSeriesTitle) {
      setEventDefault(CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep({
        content_id: id,
        content_name: title,
        content_type: TYPE_CONTENT_SERIES,
        media_language: mediaLanguage,
        is_featured_media: true,
        ui_location: uiLocation,
        ui_element: 'Tile',
      }))
    } else {
      setEventDefault(CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep({
        content_id: id,
        content_name: title,
        content_type: TYPE_CONTENT_VIDEO,
        media_language: mediaLanguage,
        media_id: feature.get('id'),
        is_featured_media: true,
        parent_series_name: parentSeriesTitle,
        parent_series_id: parentSeriesId,
        ui_location: uiLocation,
        ui_element: 'Tile',
      }))
    }

    upstreamContextOnClick(evt, { upstreamContext, setUpstreamContext })
  }

  renderSeriesTitle = (seriesTitle, seriesPath) => {
    const { onClickTitle } = this
    if (seriesTitle && seriesPath) {
      return (
        <Link
          to={seriesPath}
          data-element={SERIES_TITLE}
          onClick={onClickTitle}
          className="tile-episode__series-title"
        >
          {seriesTitle}
        </Link>
      )
    } if (seriesTitle) {
      return (
        <div className="tile-episode__series-title">{seriesTitle}</div>
      )
    }

    return null
  }

  render () {
    const {
      props,
      renderSeriesTitle,
      onClickTitle,
    } = this
    const {
      id,
      auth,
      user,
      type,
      teaser,
      feature,
      preview,
      asShare,
      heroLabel,
      staticText,
      forceAccess,
      isInPlaylist,
      addToPlaylist,
      upgradeToWatch,
      upstreamContext,
      episodeTileClass,
      displayMoreInfoButton,
      title,
      mediaLanguage,
      itemIndex,
      parentSeriesId,
      parentSeriesTitle,
      uiLocation,
    } = props
    const itemClass = _isArray(episodeTileClass)
      ? episodeTileClass.join(' ')
      : episodeTileClass
    const ga4EventData = fromJS({
      content_id: id,
      content_type: TYPE_CONTENT_VIDEO,
      content_name: title,
      parent_series_id: parentSeriesId,
      parent_series_name: parentSeriesTitle,
      ui_location: uiLocation,
    })
    return (
      <div data-type={type} className={itemClass ? `tile-episode ${itemClass}` : 'tile-episode'}>
        <WatchAccess
          auth={auth}
          user={user}
          preview={preview}
          feature={feature}
          accessCheck={asShare ? ACCESS_CHECK_SHARE_FEATURE_GEO : ACCESS_CHECK_AUTH_FEATURE_GEO}
        >
          <WatchAccessDenied>
            <NotAvailable
              type={TYPE_NOT_AVAILABLE_OVERLAY}
              message={staticText.getIn(['data', 'notAvailableInRegion'])}
            />
          </WatchAccessDenied>
          <WatchAccessAllowed>{renderLabel(props.label)}</WatchAccessAllowed>
        </WatchAccess>
        <TileHero
          asShare={asShare}
          forceAccess={forceAccess}
          displayMoreInfoButton={displayMoreInfoButton}
          id={id}
          type={type}
          image={props.image}
          url={props.url}
          hasPlayIcon
          auth={props.auth}
          heroLabel={heroLabel}
          watchType={WATCH_NODE_TYPE_FEATURE}
          preview={props.preview}
          feature={props.feature}
          showMoreInfo={props.showMoreInfo}
          toolTipComponent={props.toolTipComponent}
          active={props.active}
          onClickWatch={props.onClickWatch}
          isInPlaylist={isInPlaylist}
          addToPlaylist={addToPlaylist}
          upstreamContext={upstreamContext}
          upgradeToWatch={upgradeToWatch}
          upgradeToWatchLabel={props.label}
          title={title}
          mediaLanguage={mediaLanguage}
          itemIndex={itemIndex}
          parentSeriesId={parentSeriesId}
          parentSeriesTitle={parentSeriesTitle}
          uiLocation={uiLocation}
        />
        {!props.onlyShowHero
        && <React.Fragment>
          {renderTileProgressBar(props.userInfo, props.duration)}
          <div className="tile-episode__top-meta">
            <Vote
              className="vote--right-align vote--small"
              auth={props.auth}
              vote={props.vote}
              size={VOTE_SIZE_SMALL}
              voteDown={props.voteDown}
              voteId={props.voteId}
              ga4EventData={ga4EventData}
            />
            {renderTopMeta(props, renderSeriesTitle)}
          </div>
          <Link
            className="tile-episode__title"
            data-element={VIDEO_TITLE}
            onClick={onClickTitle}
            to={props.url}
          >
            {title}
          </Link>
          <div className="tile-episode__bottom-meta">
            {renderBottomMeta(props, formatDuration)}
          </div>
          {teaser ? <div className="tile-episode__teaser">{teaser}</div> : null}
        </React.Fragment>}
      </div>
    )
  }
}

TileEpisode.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  app: ImmutablePropTypes.map.isRequired,
  active: PropTypes.bool,
  episodeTileClass: PropTypes.array,
  title: PropTypes.string.isRequired,
  seriesTitle: PropTypes.string,
  seriesPath: PropTypes.string,
  image: PropTypes.string.isRequired,
  episode: PropTypes.number,
  season: PropTypes.number,
  duration: PropTypes.number,
  label: PropTypes.string,
  userInfo: ImmutablePropTypes.map,
  vote: PropTypes.number,
  voteId: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  host: PropTypes.string,
  asShare: PropTypes.bool,
  yogaStyle: PropTypes.string,
  yogaLevel: PropTypes.string,
  yogaLevelPath: PropTypes.string,
  yogaStylePath: PropTypes.string,
  yogaDurationPath: PropTypes.string,
  fitnessStyle: PropTypes.string,
  fitnessLevel: PropTypes.string,
  fitnessLevelPath: PropTypes.string,
  fitnessStylePath: PropTypes.string,
  fitnessDurationPath: PropTypes.string,
  meditationStyle: PropTypes.string,
  onlyShowHero: PropTypes.bool,
  showMoreInfo: PropTypes.bool.isRequired,
  toolTipComponent: PropTypes.element,
  preview: ImmutablePropTypes.map.isRequired,
  feature: ImmutablePropTypes.map.isRequired,
  onClickWatch: PropTypes.func,
  staticText: ImmutablePropTypes.map.isRequired,
  isInPlaylist: PropTypes.bool,
  addToPlaylist: PropTypes.bool,
  upstreamContext: ImmutablePropTypes.map,
  heroLabel: PropTypes.string,
  teaser: PropTypes.string,
  upgradeToWatch: PropTypes.bool,
  forceAccess: PropTypes.oneOf([
    ACCESS_FEATURE,
    ACCESS_PREVIEW,
  ]),
  isGuide: PropTypes.bool,
}

TileEpisode.defaultProps = {
  vote: 0,
}

export default compose(
  connectRouter(),
  connect(
    (state) => ({
      app: state.app,
      user: state.user,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setUpstreamContext: actions.upstreamContext.setUpstreamContext,
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
  connectStaticText({ storeKey: 'tileEpisode' }),
)(TileEpisode)
